import React, { useState } from "react";

import errors, { IAliancaErrors } from "../../Utils/ExtractErrors";
import CategoriaRepository from "../../Repositories/CategoriaRepository";
import CustomLoader from "../../components/CustomLoader";

import { Form, Modal, InputProps, Loader, Dimmer, Label, Input, Radio } from "semantic-ui-react";
import { toast } from "react-toastify";

import ModalApp from "../../components/ModalApp";

interface State {
    nome: string;
    status: number;
    apiErrors: IAliancaErrors;
}

interface Props {
    onSuccess: () => void;
}

const initialState: State = {
    nome: "",
    status: 1,
    apiErrors: { errors: [] }
}


const CadastrarCategoria: React.FC<Props> = ({ onSuccess }) => {

    const [loading, setLoading] = useState<boolean>(false);
    const [state, setState] = useState<State>(initialState);
    const [open, setOpen] = useState<boolean>(false);


    const handleSubmitForm = async () => {
        try {
            setLoading(true);

            const { nome, status } = state;

            const response = await CategoriaRepository.Insert({ nome, status });

            toast(`🎉 ${response.message}`, { position: "top-center", type: "success" });
            setOpen(false);
            onSuccess();

        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            setState({ ...state, apiErrors: err.response.data });

            const error = errors.getApiErrors(state.apiErrors);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }

        setLoading(false);
    }

    const handleOpen = () => {
        setState(initialState);
        setOpen(true);
    }

    const handleClose = () => { setOpen(false); }

    const hasError = (key: string) => {
        return errors.hasError(state.apiErrors, key);
    }

    const getMessage = (key: string) => {
        return errors.getMessage(state.apiErrors, key);
    }

    const handleChange = (e: any, { value }: any) => setState({...state, status: value})


    const cadastrarContent = (
        <Modal.Content scrolling>
            {loading &&
                <Dimmer active inverted>
                    <CustomLoader />
                </Dimmer>}
            {!loading &&
                <Form>
                    <Form.Field error={hasError("Nome")} required>
                        <label>Nome</label>
                        <Input
                            placeholder="Nome"
                            value={state.nome}
                            onChange={(e: InputProps) => setState({ ...state, nome: e.target.value })}
                        />
                        {hasError("Nome") && <Label pointing prompt>{getMessage("Nome")}</Label>}
                    </Form.Field>
                    <Form.Group inline>
                        <label>Status</label>
                        <Form.Field
                            control={Radio}
                            label="Ativo"
                            value={1}
                            checked={state.status === 1}
                            onChange={handleChange}
                        />
                        <Form.Field
                            control={Radio}
                            label="Inativo"
                            value={0}
                            checked={state.status === 0}
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Form>}
        </Modal.Content>
    );

    return (
        <ModalApp
            open={open}
            handleOpen={handleOpen}
            handleClose={handleClose}
            title="Cadastrar"
            content={cadastrarContent}
            trigger={{
                icon: "add",
                color: "pink",
                content: "Nova",
                labelPosition: "left",
                floated: "right"
            }}
            onSuccess={{ content: "Salvar", func: () => handleSubmitForm() }}
        />
    );
};

export default CadastrarCategoria;
